// Import lazyload library
import 'lazysizes';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes/plugins/respimg/ls.respimg';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/attrchange/ls.attrchange';
import 'lazysizes/plugins/object-fit/ls.object-fit';



// Settings: https://github.com/aFarkas/lazysizes#js-api
window.lazySizesConfig = window.lazySizesConfig || {};

//page is optimized for fast onload event
lazySizesConfig.loadMode = 1;

// Run image replacement before lazyload
document.addEventListener('lazybeforeunveil', function(e){
    window.updateImgSrc(e);
});
// Run image replacement before lazyload
document.addEventListener('lazyloaded', function(e){
    window.imageReady(e);
});

// Listen for image error events
document.addEventListener('error', function(e){
    window.imageError(e);
}, true);



// Update image source to AWS serverless images url
// Function triggered from Lazyload event (lazybeforeunveil)
window.updateImgSrc = function(e,resize)
{
    //console.log('-- ' + e.target.tagName + ' ---------------');
    //console.log(e);

    const $webien = window.webienImages;

    // If on local environment, just leave everything since we need public url:s to work
    if($webien.isLocal){
        return;
    }

    var el,
        srcSet = false,
        imgFit = '',
        imgPosition = 'centre',
        fullSizes = [],
        imgWidth = 0,
        imgHeight = 0,
        imgQuality = parseInt($webien.settings.compression),
        hasRatio = false,
        imgRatio = 1,
        useLocalFiles = $webien.localFiles,
        publicKey = $webien.publicKey;

    if(resize){
        el = e;
    } else {
        el = e.target;
    }

    // Distribution domains
    var resizeDistribution =  $webien.imageDistribution + '/';
    var mainDistribution = $webien.mainDistribution + '/';

    var attributes = el.dataset;

    if(typeof attributes.srcset != 'undefined'){
        // --- img tags
        if(resize){
            srcSet = attributes.original;
        } else {
            srcSet = attributes.srcset;
        }
        if(attributes.optimize === "0"){ // Check if optimization has been deactivated on widget
            imgQuality = 100;

            if(attributes.useoriginal === "1"){ // If use original is checked, exit
                return;
            }
        }
        srcSet = attributes.srcset;

        imgWidth = el.width;
        imgHeight = 9999; // we dont really have the height of the original image yet, so make it fit
        imgFit = ['inside']; //  Keep original aspect ratio
        imgPosition = ['left top'];

        // Check for ratios
        if(attributes.ratio && attributes.ratio !== 'none'){
            hasRatio = true;
            imgRatio = attributes.ratio.split('x');
            imgRatio = (imgRatio[1]/imgRatio[0]);
            imgHeight = imgWidth * imgRatio;
            imgFit = ['cover'];
            imgPosition = [attributes.focus]; // Focus strategy
        }


    } else if(typeof attributes.bgset != 'undefined'){
        // --- background images
        // Set some default values if not specified.. (usually when created outside Elementor)
        if(!("bgfit" in attributes)) attributes.bgfit = 'cover';
        if(!("bgpos" in attributes)) attributes.bgpos = 'centre';
        if(!("original" in attributes)) attributes.original = attributes.bgset;
        if(!("fullsizes" in attributes)) attributes.fullsizes = '1000x1000';

        // If custom pos, return full image. To much hazzle to get it right for now..
        if(attributes.bgpos === 'initial' || attributes.bgpos === 'custom'){
            return;
        }

        if(resize){
            srcSet = attributes.original;
        } else {
            srcSet = attributes.bgset;
        }

        imgWidth = el.scrollWidth;
        imgHeight = el.scrollHeight;
        imgFit = attributes.bgfit.split(',');
        imgPosition = attributes.bgpos.split(',');
        fullSizes = attributes.fullsizes.split(',');

    }

    // If no srcset found, return
    if(!srcSet){
        return;
    }

    // only continue if image is on aws
    if(srcSet.indexOf(mainDistribution) === -1) {
        //console.log(' -- NOT VALID SRC URL --');
        //console.log(e);
        return;
    }


    function buildUrl(src,srcCount){

        // Lets build our soon to be base64 string

        let path = src;

        // If source is on AWS, extract path only
        if(!useLocalFiles) {
            // Extract path from url
            var regex = /(http[s]?:\/\/)?([^\/\s]+\/)(.*)/;

            var urlParts = src.match(regex);
            path = urlParts[3]; // holds the path

            // Remove leading slash
            path = path.replace(/^\/+/g, '');
        }

        // Check format
        var extension = path.split('.').pop();

        // Check for svg
        if( extension === 'svg'){
            return src;
        }


        // Both Avif and WebP will perform different from jpeg at different compression levels
        // We adjust the compression in a very generic way here. More -> https://www.industrialempathy.com/posts/avif-webp-quality-settings/#quality-settings-for-a-range-of-jpeg-qualities
        var imgQualityAvif = imgQuality-10;
        var imgQualityWebp = imgQuality > 94 ? 100 : imgQuality+5;

        // Build json object
        var obj = {};

        if(useLocalFiles) {
            obj.imageUrl = path;
        } else {
            obj.bucket = $webien.awsBucket;
            obj.key = path;
        }

        // Set public key if not set
        if(publicKey) {
            obj.publicKey = publicKey;
        }

        obj.edits = {};

        // Wait until avif support is ready
        //obj.edits.avif = {};
        //obj.edits.avif.quality = imgQualityAvif;
        //obj.edits.avif.speed = 8; // 0 (slowest/smallest), 8 (fastest/largest)

        obj.edits.webp = {};
        obj.edits.webp.quality =  imgQualityWebp;

        // No need for jpeg info
        //obj.edits.jpeg = {};
        //obj.edits.jpeg.quality = imgQuality;


        var w,
            h,
            dimensions,
            pixelRatio = 1;

        // If retina is enabled, check current device pixelratio
        if($webien.settings.retina){
            pixelRatio = window.devicePixelRatio;
        }

        if(imgFit[srcCount] === 'auto'){
            // If sizing is auto, extract a portion from full size image
            // Calculate where to start our extraction
            var startLeft = 0;
            var startTop = 0;

            dimensions  = fullSizes[srcCount].split('x');
            w = parseFloat(dimensions[0]);
            h = parseFloat(dimensions[1]);

            // Adjust dimensions up to nearest 100 so we dont bloat the cache with sizes for each unique pixel dimensions
            imgWidth = pixelRatio * Math.ceil(imgWidth/100)*100;
            imgHeight = pixelRatio * Math.ceil(imgHeight/100)*100;

            // Double check that dimensions is not bigger than original image
            if(imgWidth > w){ imgWidth = w }
            if(imgHeight > h){ imgHeight = h }

            if(imgPosition[srcCount] === 'left top'){ startLeft = 0; startTop = 0; }
            if(imgPosition[srcCount] === 'top'){ startLeft = (w/2) - (imgWidth/2); startTop = 0; }
            if(imgPosition[srcCount] === 'right top'){ startLeft = w - imgWidth; startTop = 0; }

            if(imgPosition[srcCount] === 'left'){ startLeft = 0; startTop = (h/2) - (imgHeight/2); }
            if(imgPosition[srcCount] === 'centre'){ startLeft = (w/2) - (imgWidth/2); startTop = (h/2) - (imgHeight/2); }
            if(imgPosition[srcCount] === 'right'){ startLeft = w - imgWidth; startTop = (h/2) - (imgHeight/2); }

            if(imgPosition[srcCount] === 'left bottom'){ startLeft = 0; startTop = h - imgHeight; }
            if(imgPosition[srcCount] === 'bottom'){ startLeft = (w/2) - (imgWidth/2); startTop = h - imgHeight; }
            if(imgPosition[srcCount] === 'right bottom'){ startLeft = w - imgWidth; startTop = h - imgHeight; }

            if(imgPosition[srcCount] === 'custom'){
               // console.log('FIX CUSTOM POS..');
            }

            // Fallback if no dimensions are set
            if(imgWidth === 0) imgWidth = null;
            if(imgHeight === 0) imgHeight = null;

            obj.edits.extract = {};
            obj.edits.extract.left = Math.ceil(startLeft);
            obj.edits.extract.top = Math.ceil(startTop);
            obj.edits.extract.width = imgWidth;
            obj.edits.extract.height = imgHeight;

        } else if(imgFit[srcCount] === 'initial'){
            // Custom size
            dimensions  = fullSizes[srcCount].split('x');
            w = dimensions[0];
            h = dimensions[1];

            var customSize = attributes.customsizes.split('|'),
                width = customSize[0],
                unit = customSize[1],
                ratio = parseFloat(dimensions[1])/parseFloat(dimensions[0]);

            if(unit === 'px'){ w = width; }
            if(unit === '%'){ w = (width/100) * imgWidth; }
            if(unit === 'vw'){ w = (width/100) * window.innerWidth; }

            h = ratio * w;

            // Adjust dimensions up to nearest 100 so we dont bloat the cache with sizes for each unique pixel dimensions
            imgWidth = pixelRatio * Math.ceil(w/100)*100;
            imgHeight = pixelRatio * Math.ceil(h/100)*100;

            // Fallback if no dimensions are set
            if(imgWidth === 0) imgWidth = null;
            if(imgHeight === 0) imgHeight = null;


            obj.edits.resize = {};
            obj.edits.resize.width = imgWidth;
            obj.edits.resize.height = imgHeight;
            obj.edits.resize.fit = 'inside';
            obj.edits.resize.withoutEnlargement = true;

        } else {
            // Else just resize image
            // Adjust dimensions up to nearest 100 so we dont bloat the cache with sizes for each unique pixel dimensions

            imgWidth = pixelRatio * Math.ceil(imgWidth/100)*100;
            imgHeight = pixelRatio * Math.ceil(imgHeight/100)*100;

            // If we have a ratio, make sure the ratio stays
            if(hasRatio){
                imgHeight = Math.ceil(imgWidth * imgRatio);
            }

            if(imgPosition[srcCount] === 'custom'){
                // console.log('FIX CUSTOM POS..');
                imgPosition[srcCount] = 'left top';
            }

            // Fallback if no dimensions are set
            if(imgWidth === 0) imgWidth = null;
            if(imgHeight === 0) imgHeight = null;

            obj.edits.resize = {};
            obj.edits.resize.width = imgWidth;
            obj.edits.resize.height = imgHeight;
            obj.edits.resize.fit = imgFit[srcCount];
            obj.edits.resize.withoutEnlargement = true;
            obj.edits.resize.position = imgPosition[srcCount];
        }

        // If modern image formats are supported, serve them first
        /*
        Avif conversion is way to slow to compress at the moment.. stay tuned
        if(window.supportsAvif){
            obj.edits.toFormat = 'avif';
        }
        else */
        if(window.supportsWebp){
            obj.edits.toFormat = 'webp';
        }

        // If format is png and webp is not supported, return png
        if(!window.supportsWebp && extension === 'png'){
            obj.edits.toFormat = 'png';
        }

        // base64 our new url to match aws serverless requirements
        // Do some unescape/encodeURI for formating åäö purpose
        return resizeDistribution + btoa(decodeURIComponent(encodeURIComponent(JSON.stringify(obj))));
    }



    // split srcset to handle each url if there are multiple responsive urls
    var regex = /[^"\'=\s]+\.(jpe?g|png|gif)/igm;

    // srcCount is for responsive src
    var srcCount = -1;
    var newSrc = srcSet.replace(regex,function(matched, index, original) {
        srcCount++;

        return buildUrl(matched,srcCount);
    });

    // Update with new source
    if(typeof attributes.srcset != 'undefined') {
        attributes.srcset = newSrc;
    } else if(typeof attributes.bgset != 'undefined') {
        attributes.bgset = newSrc;
    }
};

window.imageReady = function(e) {
    // Add class to outer image wrapper
    if(e.target.className.indexOf('main') > -1){
        if(e.target.offsetParent){
            e.target.offsetParent.classList.add("ready");
        }
    }
}

window.imageError = function(e) {
    // If we get an error, try to load the original image instead
    if(e.target.nodeName == 'IMG'){
        let attributes = e.target.dataset;

        if(typeof attributes.original != 'undefined'){
           e.target.srcset = attributes.original;
        }

        // Add class for fallback to remove aspect ratio
        e.target.parentNode.classList.add('fallback');

    }
}


// This is a helper function to not calling events more then necessary
var waitForFinalEvent = (function () {
    var timers = {};
    return function (callback, ms, uniqueId) {
        if (!uniqueId) {
            uniqueId = "Don't call this twice without a uniqueId";
        }
        if (timers[uniqueId]) {
            clearTimeout (timers[uniqueId]);
        }
        timers[uniqueId] = setTimeout(callback, ms);
    };
})();


var initialWidth = window.innerWidth;
function reportWindowSize() {
    waitForFinalEvent(function(){
        // Only run if sizing up
        if((window.innerWidth - 200) < initialWidth){
            return;
        }
        // else set new standard width and call new images
        initialWidth = window.innerWidth;

        // Update elements that has been initialized
        var elements = document.getElementsByClassName("lazyloaded");

        for (var i = 0; i < elements.length; i++) {
            //console.log(elements[i]);
            window.updateImgSrc(elements[i], true);
        }
    }, 1000); // Wait a second to reload
}

window.onresize = reportWindowSize;



// Check for modern image format support and store it in localstorage
// https://ourcodeworld.com/articles/read/630/how-to-detect-if-the-webp-image-format-is-supported-in-the-browser-with-javascript
function ImageFormatIsSupported(format, callback){
    // If the browser doesn't has the method createImageBitmap, you can't display webp format
    if(!window.createImageBitmap){
        callback(false);
        return;
    }
    // Base64 representation
    var imgdata = '';
    if(format === 'webp'){
        imgdata = 'data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoCAAEAAQAcJaQAA3AA/v3AgAA=';
    }
    if(format === 'avif'){
        imgdata = 'data:image/avif;base64,AAAAFGZ0eXBhdmlmAAAAAG1pZjEAAACgbWV0YQAAAAAAAAAOcGl0bQAAAAAAAQAAAB5pbG9jAAAAAEQAAAEAAQAAAAEAAAC8AAAAGwAAACNpaW5mAAAAAAABAAAAFWluZmUCAAAAAAEAAGF2MDEAAAAARWlwcnAAAAAoaXBjbwAAABRpc3BlAAAAAAAAAAQAAAAEAAAADGF2MUOBAAAAAAAAFWlwbWEAAAAAAAAAAQABAgECAAAAI21kYXQSAAoIP8R8hAQ0BUAyDWeeUy0JG+QAACANEkA=';
    }
    // Retrieve the Image in Blob Format
    fetch(imgdata).then(function(response){
        return response.blob();
    }).then(function(blob){
        // If the createImageBitmap method succeeds, return true, otherwise false
        createImageBitmap(blob).then(function(){
            callback(true);
        }, function(){
            callback(false);
        });
    });
}



function checkLocalStorage(key){
    var webienObject = JSON.parse(localStorage.getItem('webien'));

    if(webienObject && webienObject.hasOwnProperty('imageOptimizer')){
        if(key === 'webp' && webienObject.imageOptimizer.hasOwnProperty('webp')){
            return webienObject.imageOptimizer.webp;
        }
        if(key === 'avif' && webienObject.imageOptimizer.hasOwnProperty('avif')){
            return webienObject.imageOptimizer.avif;
        }
    }

    // No values are stored, set them here
    // For webp we can check directly against a canvas
    if(key === 'webp'){
        var webpSupported = support_format_webp();
        updateLocalStorage('webp', webpSupported);
        return webpSupported;
    }

    // Avif is handled async and will return false before localstorage is set, so webp will step in the first load
    ImageFormatIsSupported('avif', function(isSupported){
        updateLocalStorage('avif', isSupported);
        return isSupported
    });

    // Since the compability check is async, we return false.
    // Giving the vitor standard jpeg's on the first load before we have any local storage.
    return false;
}

// Set localstorage from image formats support
function updateLocalStorage(key, val){
    var webienObject = JSON.parse(localStorage.getItem('webien'));
    if(!webienObject){
        webienObject = {};
    }
    if(!webienObject.imageOptimizer){
        webienObject.imageOptimizer = {};
    }
    if(key === 'webp'){
        webienObject.imageOptimizer.webp = val;
    }
    if(key === 'avif'){
        webienObject.imageOptimizer.avif = val;
    }
    localStorage.setItem('webien', JSON.stringify(webienObject));
}


function support_format_webp() {
    var elem = document.createElement('canvas');
    if (!!(elem.getContext && elem.getContext('2d'))) {
        return elem.toDataURL('image/webp').indexOf('data:image/webp') == 0;
    } else {
        return false;
    }
}



// Handle special case for slick slider when cloned images is generated after this initialization and needs to be parsed as well
// Wait until page is fully loaded
window.addEventListener("load", (event) => {
    let sliders = document.querySelectorAll('.slick-slider');

    if (sliders.length > 0) {
        for (let i = 0; i < sliders.length; i++) {
            let slider = sliders[i];
            let imgElem = slider.querySelectorAll('.lazyloading, .lazyload');

            if (imgElem.length > 0) {
                imgElem.forEach(function (img) {
                    lazySizes.loader.unveil(img);
                });
            }
        }
    }
});




function isLocalDev() {
    let domain = window.location.hostname;
    let re = /^(?!:\/\/)([a-zA-Z0-9-]+\.){0,5}[a-zA-Z0-9-][a-zA-Z0-9-]+\.[a-zA-Z]{2,64}?$/gi;
    let validDomain = re.test(domain);
    let testDomain = domain.includes('.test');
    let isLocal = validDomain && testDomain;
    if(isLocal) {
        console.info('Webien image optimizer will only work on public domains, not on local environment. Local url:s will be used for now..');
    }

    return isLocal;
}

const isLocal = isLocalDev();


// Check localstorage fot saved support, set support if not
window.supportsWebp = checkLocalStorage('webp');
window.supportsAvif = checkLocalStorage('avif');
